import { render } from "./UserGroup.vue?vue&type=template&id=00a174bc"
import script from "./UserGroup.vue?vue&type=script&lang=js"
export * from "./UserGroup.vue?vue&type=script&lang=js"
script.render = render

export default script